import { useTracking } from 'lib/analytics'
import {
  registryChecklistPath,
  helloBabyPostPath,
  helloBabySampleRegistriesPath,
  storePath,
  registryExternalPath,
} from 'lib/urls'

interface useLinkDataProps {
  sharedTrackingProperties: {
    event: (properties: {
      eventCta?: string | undefined
      eventLocation: string
      eventType?: string | undefined
      eventUrl?: string | undefined
    }) => void
    eventLocation: string
  }
}

export const useLinkData = ({ sharedTrackingProperties }: useLinkDataProps) => {
  const tracker = useTracking()

  return [
    {
      iconUrl:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1676066077/checklist/checklist_color_1.svg',
      label: 'Try our registry checklist',
      description: `Let's make sure you don't forget any of the essentials!`,
      href: registryChecklistPath,
      onClick: () => {
        tracker.trackEvent({
          ...sharedTrackingProperties,
          eventCta: 'Registry Checklist',
        })
      },
    },
    {
      iconUrl:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1678807247/icons/Import_Registry.png',
      label: 'Import an existing registry',
      description: `Perfect if you've already started a baby registry somewhere else.`,
      href: registryExternalPath,
      onClick: () => {
        tracker.trackEvent({
          ...sharedTrackingProperties,
          eventCta: 'Registry Import',
        })
      },
    },
    {
      iconUrl:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1678807247/icons/Research-Guides.png',
      label: 'Research baby products',
      description:
        'Use our "best of" guides to find the perfect products for your family.',
      href: helloBabyPostPath('gear'),
      onClick: () => {
        tracker.trackEvent({
          ...sharedTrackingProperties,
          eventCta: 'Guides',
        })
      },
    },
    {
      iconUrl:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1678807247/icons/Starter_Registries.png',
      label: 'Use our sample registries',
      description:
        'A great place to gain inspiration and begin checking things off your list.',
      href: helloBabySampleRegistriesPath,
      onClick: () => {
        tracker.trackEvent({
          ...sharedTrackingProperties,
          eventCta: 'Starter Registries',
        })
      },
    },
    {
      iconUrl:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1678807247/icons/Babylist_Shop.png',
      label: 'Browse the Babylist Shop',
      description:
        'Discover the best baby gear tested by our experts and real parents.',
      href: storePath,
      onClick: () => {
        tracker.trackEvent({
          ...sharedTrackingProperties,
          eventCta: 'Babylist Store',
        })
      },
    },
  ]
}
